import React from "react";
import * as Icon from "react-bootstrap-icons";

const Footer = () => {
  return (
    <footer
      className="text-light mt-auto"
      style={{
        background: "linear-gradient(to right, #0d6efd, #0dcaf0)",
        padding: "15px 20px",
        boxShadow: "0 -2px 10px rgba(0,0,0,0.08)",
      }}
    >
      <div className="container-fluid">

        <div className="row align-items-center">

          {/* Left Side */}
          <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-2">

              <div
                className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "35px",
                  height: "35px",
                }}
              >
                <Icon.CpuFill size={18} />
              </div>

              <div>
                <h6 className="mb-0 fw-bold">
                  MIS & ICT Division
                </h6>

                <small style={{ opacity: 0.9 }}>
                  Bangladesh Steel & Engineering Corporation
                </small>
              </div>

            </div>
          </div>

          {/* Right Side */}
          <div className="col-md-6 text-center text-md-end">

            <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-end align-items-center gap-2">

              <small>
                © {new Date().getFullYear()} All Rights Reserved
              </small>

              <span className="d-none d-md-inline">|</span>

              <small className="fw-semibold">
                Design & Developed by MIS & ICT
              </small>

            </div>

          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;
